export const availableApps = [
    {
        title: "Gestor de Dados",
        path: 'datamanager',
        glyph: "hdd",
        defaultRoute: "lines"
    },
    {
        title: "Horários à Paragem",
        path: 'bussched',
        glyph: "list",
        defaultRoute: "schedules/generate"
    },
    {
        title: "Mapas Esquemáticos à Paragem",
        path: 'busmap',
        glyph: "file",
        defaultRoute: "new"
    },
    {
        title: "Spider Maps",
        path: 'spidermap',
        glyph: "file",
        defaultRoute: "new"
    },
    {
        title: "Placas de Paragem",
        path: 'stopplates',
        glyph: "credit-card"
    },
    {
        title: "Mapas Esquemáticos de Rede",
        path: 'schematicmap',
        glyph: "list",
        defaultRoute: "new"
    }
];

export class AppManager {
    getApp(path) {
        const output = availableApps.filter(function (app) {
            return app.path === path;
        });

        if(0 === output.length) {
            return availableApps[0];
        }

        return output[0];
    }
}

export const appManager = new AppManager();
